import { forwardRef } from 'react';
import { IPageSection } from '../../types';
import { TabSectionPartnerPage } from '../tab-section-partner-page/tab-section-partner-page';

export const GuidesSection: React.FC<IPageSection> = forwardRef(
  ({ id, postData }, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
    if (!postData) return <></>;
    return (
      <div
        data-testid={id}
        id={id}
        ref={ref}
        className="wg-container mb-24 sm:mb-0 sm:bg-grey-190 sm:pt-[75px]"
      >
        <h2 className="mb-12 sm:mb-7">Calculators and Resources</h2>
        <TabSectionPartnerPage postData={postData} />
      </div>
    );
  }
);

GuidesSection.displayName = 'GuidesSection';
